module.exports = __webpack_public_path__ + "img/VisionTB.36ebc62e.jpg";